<div class="chat-and-shop-button-container">
  @if (chatUrl(); as chatUrl) {
    <app-widget-button [href]="chatUrl" icon="chat"></app-widget-button>
  }
  @if (shopUrl(); as shopUrl) {
    <app-widget-button [href]="shopUrl" icon="cart"> </app-widget-button>
  }
</div>
